import Vue from 'vue'
import Vuex from 'vuex'

// import VuexPersistedState from 'vuex-persistedstate'

import Address from './address'
import Application from './application'
import Counts from './state'
import Family from './family'
import Hospitals from './hospitals'
import NamePrefix from './namePrefix'
import Occupation from './occupation'
import payment from './payment'
import Plan from './plan'
import quotation from './quotation'
import Referral from './referral'
import Uploadfile from './uploadfile'
import Validate from './validate'
import webSocket from './webSocket'

Vue.use(Vuex)

import VueSession from 'vue-session'
Vue.use(VueSession, { persist: true })

export default new Vuex.Store({
  modules: {
    Address,
    Application,
    Counts,
    Family,
    Hospitals,
    NamePrefix,
    Occupation,
    payment,
    Plan,
    quotation,
    Referral,
    Uploadfile,
    Validate,
    webSocket,
  },
  // plugins: [VuexPersistedState()],
  // strict: debug
})
